import React from "react";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import styles from "../../engagement_letter/ContentBlocksPage/components/ActionsRenderer/ActionsRenderer.module.css";
import { saveFirmRules } from "../RulesModal/RulesModal.service";
import { CustomToaster } from "../../reusable_components/Toasters/toaster";
import { GridApi } from "ag-grid-community";
import { Rule } from "./ApprovalConfig.types";

export const BtnCellRenderer =
  (
    setSelectedRowData: React.Dispatch<React.SetStateAction<Rule | undefined>>,
    setRuleType: React.Dispatch<React.SetStateAction<string>>,
    setAddRulesModalShow: React.Dispatch<React.SetStateAction<boolean>>,
    setRuleId: React.Dispatch<React.SetStateAction<number | undefined>>,
    setRuleName: React.Dispatch<React.SetStateAction<string>>,
    ruleType: string,
    loadRules: () => Promise<void>
  ) =>
    (props: any) => {
      const editClick = () => {
        setSelectedRowData(props.data);
        setRuleType(ruleType);
        setAddRulesModalShow(true);
        setRuleId(props.data.RuleId);
        setRuleName(props.data.RuleName);
      };

      const handleDeleteClick = async () => {
        const deletedRule = props.data;

        const allRows: Rule[] = [];
        props.api.forEachNode((node: any) => {
          allRows.push(node.data);
        });

        let order = 1;
        const updatedRules = allRows.map(r => {
          if (r.RuleId === deletedRule.RuleId) {
            return { ...r, Active: "N" };
          }
          if (r.RuleName?.toUpperCase() === "DEFAULT" || r.Active === "N") {
            return r;
          }
          return { ...r, ExecutionOrder: order++ };
        });

        const response = await saveFirmRules(updatedRules);
        if (response) {
          CustomToaster({
            type: "success",
            customized_message: "Deleted rule successfully!",
            api_message: "",
          });
          await loadRules();
        }
      };

      return (
        <div>
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={<Tooltip id="button-tooltip">Edit rule</Tooltip>}
          >
            <div className={styles.tooltipWrapper}>
              <Button
                className={`${styles.editActionButton} ${styles.actionButton}`}
                onClick={editClick}
              >
                <Icon.PencilSquare />
              </Button>
            </div>
          </OverlayTrigger>

          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={<Tooltip id="button-tooltip">Delete rule</Tooltip>}
          >
            <span className={styles.tooltipWrapper}>
              <Button
                className={`${styles.deleteActionButton} ${styles.actionButton}`}
                onClick={handleDeleteClick}
              >
                <Icon.Trash />
              </Button>
            </span>
          </OverlayTrigger>
        </div>
      );
    };

export const ExecutionModeRenderer = (props: any) =>
  (props.value ?? "STANDARD") === "ALWAYS" ? "Always" : "Standard";

export const ListRenderer = (props: any) => {
  let value = props.value ?? "";

  // Replace literal "\n" with actual newlines
  value = value.replace(/\\n/g, "\n");

  const lineStyle: React.CSSProperties = {
    whiteSpace: "normal",
    wordBreak: "break-word",
  };

  const lines = value.split("\n").map((line: string, idx: number) => (
    <div key={idx} style={lineStyle}>{line}</div>
  ));

  return <div style={{ width: "100%" }}>{lines}</div>;
};

export const handleRowReorder = async (
  event: { api: GridApi },
  setRowData: React.Dispatch<React.SetStateAction<Rule[]>>
) => {
  const newOrder: Rule[] = [];
  const orderByMode: Record<string, number> = {};
  let hasChanged = false;

  event.api.forEachNode((node: any) => {
    if (node.data.RuleName?.toUpperCase() === "DEFAULT") {
      // Keep default rule untouched
      newOrder.push({
        ...node.data,
        ExecutionOrder: node.data.ExecutionOrder
      });
    } else {
      const mode = (node.data.ExecutionMode ?? "STANDARD").toUpperCase();
      const newExecutionOrder = (orderByMode[mode] ?? 0) + 1;
      orderByMode[mode] = newExecutionOrder;

      if (node.data.ExecutionOrder !== newExecutionOrder) {
        hasChanged = true;
      }
      newOrder.push({
        ...node.data,
        ExecutionOrder: newExecutionOrder,
      });
    }
  });

  if (hasChanged) {
    setRowData(newOrder);
    await saveFirmRules(newOrder);
  }
};